/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `tourism_business_studies` - Turism / Afaceri / Studii
 * * `job_contract` - Contract de muncă
 * * `sport` - Sport fără participare la competiții
 * * `sport_competitions` - Sport cu participare la competiții
 */
export enum TravelCategoryEnum {
  TOURISM_BUSINESS_STUDIES = 'tourism_business_studies',
  JOB_CONTRACT = 'job_contract',
  SPORT = 'sport',
  SPORT_COMPETITIONS = 'sport_competitions',
}
